<template>
    <div :class="['center-modal',{'on': show}]" v-if="modal">
        <div class="mask"></div>
        <div class="content">
            <img src="../assets/images/toast_prompt_pic.png" alt="icon" v-if="icon===1">
            <img src="../assets/images/toast_certified_pic.png" alt="icon" v-if="icon===2">
            <img src="../assets/images/toast_success_pic.svg" alt="icon" v-if="icon===3">
            <p>{{content}}</p>
            <button type="button" class="btn" @click.stop="submit">{{okText}}</button>
        </div>
    </div>
</template>

<script>

    export default {
        name: "Modal",
        data() {
            return {
                modal: false,
                show: false,
                icon: 1,
                content: '',
                okText: '确认',
                callBack: null,
            }
        },
        methods: {
            showModal(op) {
                this.modal = true
                setTimeout(() => {
                    this.show = true
                }, 100)
                this.icon = op.icon || 1
                this.okText = op.okText
                this.content = op.content
                if (op.ok) {
                    this.callBack = op.ok
                }
            },
            hide() {
                this.show = false
                this.modal = false
            },
            submit() {
                if (typeof this.callBack === 'function') {
                    this.callBack()
                    this.callBack = null
                }
                this.hide()
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/stylesheets/Mixins";
    .center-modal {
        .mask, .content {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1000;
            opacity: 0;
            transition: opacity .3s ease-in-out;
        }
        &.on {
            .mask, .content {
                opacity: 1;
            }
        }
        .mask {
            top: 0;
            height: 100%;
            background-color: rgba(0, 0, 0, .8);
        }
        .content {
            top: 50%;
            width: 480px;
            height: 355px;
            margin: 0 auto;
            background-color: #fff;
            text-align: center;
            @include radius(5px);
            @include prefix-property(transform, translateY(-50%));
            img {
                margin-top: 60px;
                width: 80px;
            }
            p {
                padding: 15px 30px 0;
                font-size: 20px;
                line-height: 30px;
            }
            button {
                margin-top: 40px;
                width: 190px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue